import { Navigate, Route, Routes } from 'react-router-dom';

import { PERMISSION } from 'src/features/auth';
import { UserManagementLayout } from 'src/features/userManagement/components';
import { Clients } from 'src/features/userManagement/routes/Clients';
import DeactivatedUsers from 'src/features/userManagement/routes/DeactivatedUsers';
import { Invitations } from 'src/features/userManagement/routes/Invitations';
import { Users } from 'src/features/userManagement/routes/Users';
import useHasPermissions from 'src/hooks/useHasPermissions';

const UserManagementRoutes = () => {
    const permissionUser = useHasPermissions([PERMISSION.USERS]);
    const permissionInvitation = useHasPermissions([PERMISSION.USERS_INVITATION]);

    return permissionUser ? (
        <Routes>
            <Route path="" element={<UserManagementLayout />}>
                <Route path="" element={<Users />} />
                <Route path="deactivated" element={<DeactivatedUsers />} />
                {permissionInvitation && <Route path="invitations" element={<Invitations />} />}
                <Route path="clients" element={<Clients />} />
                <Route path="*" element={<Navigate to=".." />} />
            </Route>
        </Routes>
    ) : (
        <Navigate to=".." />
    );
};

export default UserManagementRoutes;
